/* eslint-disable camelcase */
// visibility: 'public' | 'internal' | 'developer' — who sees this setting
// levels: ['platform', 'team', 'user', 'role'] — which override levels are supported
// defaultValueOverrides : default overrides for levels (platform, team, user)

export const CDPSettingsConfig = {
  categories: {
    crm: { key: 'crm', title: 'CRM', description: 'Manage CRM settings and preferences.' },
    ads: { key: 'ads', title: 'Ads', description: 'Configure ADS settings and preferences.' },
    automations: { key: 'automations', title: 'Automations', description: 'Manage automation settings and preferences.' },
    whatsapp: { key: 'whatsapp', title: 'WhatsApp', description: 'Configure WhatsApp settings and preferences.' },
    staff: { key: 'staff', title: 'Staff', description: 'Configure staff settings and preferences.' },
    campaigns: { key: 'campaigns', title: 'Campaigns', description: 'Manage campaign settings and preferences.' },
    popups: { key: 'popups', title: 'Popups', description: 'Configure popup settings and preferences.' },
    'mobile-view': { key: 'mobile-view', title: 'Mobile App', description: 'Manage mobile view settings and preferences.' },
    'web-analytics': { key: 'web-analytics', title: 'Web Analytics', description: 'Manage web analytics settings and preferences.' },
    'ai-insights': { key: 'ai-insights', title: 'AI Insights', description: 'Manage AI insights settings and preferences.' },
    notifications: { key: 'notifications', title: 'Notifications', description: 'Configure notification email settings.' },
  },
  sections: {
    general: { key: 'general', title: 'GENERAL' },
    contacts: { key: 'contacts', title: 'CONTACTS' },
    accounts: { key: 'accounts', title: 'ACCOUNTS' },
    inboxes: { key: 'inboxes', title: 'INBOXES' },
    bulk_import: { key: 'bulk_import', title: 'BULK IMPORT' },
    drip_campaign_settings: { key: 'drip_campaign_settings', title: 'SEQUENCES' },
    email_broadcast_settings: { key: 'email_broadcast_settings', title: 'EMAIL BROADCAST' },
    popups_settings: { key: 'popups_settings', title: 'POPUPS' },
  },
  settings: {
    MULTI_LOCATION: {
      key: 'MULTI_LOCATION',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Teams',
      description: 'Enable teams functionality across the app',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    TEAMS_MENU: {
      key: 'TEAMS_MENU',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Teams Menu',
      description: 'Enable the teams menu item',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    USAGE_WALLET_MENU: {
      key: 'USAGE_WALLET_MENU',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Usage Wallet',
      description: 'Enable the usage wallet menu item',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    TEAMS_UNIFIED_VIEW: {
      key: 'TEAMS_UNIFIED_VIEW',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Teams Unified View',
      description: 'Show a unified view across all teams for staff who only have team access',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_DASHBOARD_TEAMS_CHART: {
      key: 'CRM_DASHBOARD_TEAMS_CHART',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Teams Chart',
      description: 'Enable the teams chart on the CRM dashboard (only applies when Teams is enabled)',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_DASHBOARD_ASSIGNEE_CHART: {
      key: 'CRM_DASHBOARD_ASSIGNEE_CHART',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Assignees Chart',
      description: 'Enable the assignees chart on the CRM dashboard',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_DASHBOARD_UTM_CAMPAIGNS_CHART: {
      key: 'CRM_DASHBOARD_UTM_CAMPAIGNS_CHART',
      category: 'crm',
      section: 'general',
      visibility: 'internal',
      title: 'UTM Campaigns Chart',
      description: 'Enable the UTM campaigns chart on the CRM dashboard',
      type: 'boolean',
      defaultValue: 'enabled',
      levels: [],
    },
    CRM_DASHBOARD_UTM_CONTENTS_CHART: {
      key: 'CRM_DASHBOARD_UTM_CONTENTS_CHART',
      category: 'crm',
      section: 'general',
      visibility: 'internal',
      title: 'UTM Contents Chart',
      description: 'Enable the UTM contents chart on the CRM dashboard',
      type: 'boolean',
      defaultValue: 'enabled',
      levels: [],
    },
    CRM_DASHBOARD_EXPORT_BUTTON: {
      key: 'CRM_DASHBOARD_EXPORT_BUTTON',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Export Button',
      description: 'Enable the export button on the CRM dashboard',
      type: 'boolean',
      defaultValue: 'PRODUCTSU,SUPERUSER,SLIXTA',
      levels: ['team', 'user', 'role'],
    },
    CRM_ACCOUNT_DASHBOARD_CHARTS: {
      key: 'CRM_ACCOUNT_DASHBOARD_CHARTS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Account Dashboard Charts',
      description: 'Charts shown on Accounts and Contacts (ABM) dashboards. Format: field:chartType|... e.g. industry:pie|employeeCount:bar|tags:bar|country:pie|city:bar',
      type: 'string',
      defaultValue: 'industry:pie|employeeCount:bar|tags:bar|country:pie|city:bar',
      levels: [],
      fields: [
        {
          key: 'CRM_ACCOUNT_DASHBOARD_CHARTS',
          type: 'edit_text',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    ORG_LISTENERS_TO: {
      key: 'ORG_LISTENERS_TO',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Org Listeners (To)',
      description: 'Email addresses added to org notification To recipients (form submissions, inbound inbox email, etc.)',
      type: 'check_box',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'ORG_LISTENERS_TO',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'To emails',
          tip: 'Add email addresses to notify as To',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    ORG_LISTENERS_CC: {
      key: 'ORG_LISTENERS_CC',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Org Listeners (Cc)',
      description: 'Email addresses added to org notification Cc recipients (form submissions, inbound inbox email, etc.)',
      type: 'check_box',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'ORG_LISTENERS_CC',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'Cc emails',
          tip: 'Add email addresses to notify as Cc',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    ORG_LISTENERS_BCC: {
      key: 'ORG_LISTENERS_BCC',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Org Listeners (Bcc)',
      description: 'Email addresses added to org notification Bcc recipients (form submissions, inbound inbox email, etc.)',
      type: 'check_box',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'ORG_LISTENERS_BCC',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'Bcc emails',
          tip: 'Add email addresses to notify as Bcc',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    CRM_CONTACT_EXPORT_FILTERED: {
      key: 'CRM_CONTACT_EXPORT_FILTERED',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Export Filtered',
      description: 'Allow exporting of filtered CRM data',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    CRM_EXPORT_ALL_TIME: {
      key: 'CRM_EXPORT_ALL_TIME',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Export All',
      description: 'Allow exporting all-time CRM data',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    CRM_EXPORT_DATE_RANGE: {
      key: 'CRM_EXPORT_DATE_RANGE',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Export Date Range',
      description: 'Allow exporting a date range (disables Filtered and All Time exports)',
      type: 'boolean',
      defaultValue: 'enabled',
      levels: ['platform', 'team', 'user', 'role'],
    },
    TENANT_NAME_IN_HEADER: {
      key: 'TENANT_NAME_IN_HEADER',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Tenant Name In Header',
      description: 'Show tenant name in header',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    DIALOG_SCROLLBAR: {
      key: 'DIALOG_SCROLLBAR',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Dialog Scrollbar',
      description: 'Show the vertical scrollbar on dialogs while hovered, when content overflows',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_CUSTOM_STAT_CARDS_MAX_PER_ROW: {
      key: 'CRM_CUSTOM_STAT_CARDS_MAX_PER_ROW',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Stat Cards Per Row',
      description: 'Maximum CRM stat cards per row',
      type: 'number',
      defaultValue: '7',
      fields: [
        {
          key: 'CRM_CUSTOM_STAT_CARDS_MAX_PER_ROW',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CUSTOM STAT CARDS MAX PER ROW is required',
          },
        },
      ],
    },
    CRM_JOB_ADD: {
      key: 'CRM_JOB_ADD',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Jobs',
      description: 'Show the Add Job action on the CRM jobs page',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['platform', 'team', 'user', 'role'],
    },
    CRM_JOB_ACTIONS: {
      key: 'CRM_JOB_ACTIONS',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Job Actions',
      description: 'Comma-separated whitelist of allowed CRM job action keys',
      type: 'string',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'CRM_JOB_ACTIONS',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM JOB ACTIONS is required',
          },
        },
      ],
    },
    CRM_CUSTOM_FILTERS_MAX_PER_ROW: {
      key: 'CRM_CUSTOM_FILTERS_MAX_PER_ROW',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'Quick Filter Columns',
      description: 'Number of columns for quick filters',
      type: 'number',
      defaultValue: '2',
      fields: [
        {
          key: 'CRM_CUSTOM_FILTERS_MAX_PER_ROW',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CUSTOM FILTERS MAX PER ROW is required',
          },
        },
      ],
    },
    CRM_MENU_ONEVIEW: {
      key: 'CRM_MENU_ONEVIEW',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'OneView Menu',
      description: 'Enable the OneView menu item',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_ONEVIEW_GROUPS: {
      key: 'CRM_ONEVIEW_GROUPS',
      category: 'crm',
      section: 'general',
      visibility: 'developer',
      title: 'OneView Groups',
      description: 'Define groups and filters for OneView',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_ONEVIEW_GROUPS',
          type: 'list',
          placement: 'left',
          v_required: { value: false, err: 'Required' },
          listConfig: {
            addButtonText: 'Add Group',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Display name for the group in OneView',
                v_required: { value: true, err: 'Label is required' },
              },
              {
                key: 'filter',
                type: 'edit_text',
                label: 'Filter Query',
                tip: 'Query string that defines contacts in this group',
                v_required: { value: true, err: 'Filter is required' },
              },
            ],
          },
        },
      ],
    },
    CRM_RESTRICT_VIEW_ASSIGNED_CONTACTS: {
      key: 'CRM_RESTRICT_VIEW_ASSIGNED_CONTACTS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Restrict View to Assigned Contacts',
      description: 'Restrict contact view to assigned contacts only',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    CRM_CONTACT_CARRIER_CALL: {
      key: 'CRM_CONTACT_CARRIER_CALL',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Call Direct',
      description: 'Enable direct call (carrier call)',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CLICK_TO_CALL: {
      key: 'CLICK_TO_CALL',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Call Cloud',
      description: 'Enable call cloud (click to call)',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CLICK_TO_WHATSAPP_APP: {
      key: 'CLICK_TO_WHATSAPP_APP',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Click To WhatsApp',
      description: 'Enable click to WhatsApp app',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CLICK_TO_ZOOM_PHONE: {
      key: 'CLICK_TO_ZOOM_PHONE',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Call Zoom Phone',
      description: 'Enable click to open Zoom Phone',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    ZOOM_PHONE_WEBHOOK_CREATE_LEAD: {
      key: 'ZOOM_PHONE_WEBHOOK_CREATE_LEAD',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Zoom Phone Webhook Create Lead',
      description: 'Create a new lead when an incoming Zoom Phone webhook has no matching contact',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACT_EDIT_INTERACTION: {
      key: 'CRM_CONTACT_EDIT_INTERACTION',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Edit Interaction',
      description: 'Add an edit contact interaction',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACT_EMAIL_INTERACTION: {
      key: 'CRM_CONTACT_EMAIL_INTERACTION',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Email Interaction',
      description: 'Enable contact email interactions',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_CONTACT_TEAM_EMAIL_INTERACTION: {
      key: 'CRM_CONTACT_TEAM_EMAIL_INTERACTION',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Team Email Interaction',
      description: 'Allow email interactions for team (sub-org) logins',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_INTERACTIONS_STATS: {
      key: 'CRM_INTERACTIONS_STATS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Interaction Stats',
      description: 'Stat cards to show on the interactions page',
      type: 'check_box',
      defaultValue: '',
      fields: [{
        key: 'CRM_INTERACTIONS_STATS',
        type: 'check_box',
        addOptions: true,
        placement: 'left',
        v_required: { value: false, err: '' },
        options: 'interactions',
      }],
    },
    PAYMENT_LEDGER_CARD: {
      key: 'PAYMENT_LEDGER_CARD',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Payment Ledger Card',
      description: 'Show payment ledger card',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    PAYMENT_CONFIRMATION: {
      key: 'PAYMENT_CONFIRMATION',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Payment Confirmation',
      description: 'Enable payment confirmation transactions on contacts',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACT_ASSIGNEE_NOTIFY_ON_BULK_OP: {
      key: 'CRM_CONTACT_ASSIGNEE_NOTIFY_ON_BULK_OP',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Bulk Assignee Change Notifications',
      description: 'Notify assignee change on bulk contact operations',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACT_LEAD_STATUS: {
      key: 'CRM_CONTACT_LEAD_STATUS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Lead Status Mapping',
      description: 'Map existing CRM lead statuses to custom names',
      type: 'list',
      defaultValue: '',
      listSerializer: 'colonCommaPairs',
      fields: [
        {
          key: 'CRM_CONTACT_LEAD_STATUS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'Lead status mapping is required',
          },
          listConfig: {
            addButtonText: 'Add Mapping',
            flatStorage: false,
            rowFields: [
              {
                key: 'originalStatus',
                type: 'edit_text',
                label: 'Original Status',
                tip: 'Existing CRM lead status value to map from',
                v_required: {
                  value: true,
                  err: 'Original status is required',
                },
              },
              {
                key: 'newStatus',
                type: 'edit_text',
                label: 'New Status',
                tip: 'Custom display name for this lead status',
                v_required: {
                  value: true,
                  err: 'New status is required',
                },
              },
            ],
          },
        },
      ],
    },
    CRM_CONTACT_FIELD_MAPPING: {
      key: 'CRM_CONTACT_FIELD_MAPPING',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Contact Field Mapping',
      description: 'Map query params, form submission fields, Meta lead fields, and WhatsApp flow reply fields to CRM contact fields',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_CONTACT_FIELD_MAPPING',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'Contact field mapping is required',
          },
          listConfig: {
            addButtonText: 'Add Mapping',
            flatStorage: false,
            rowFields: [
              {
                key: 'keys',
                type: 'check_box',
                label: 'Keys',
                tip: 'Input keys from query params, submissions, Meta leads, or WA flows',
                addOptions: true,
                options: [],
                v_required: {
                  value: true,
                  err: 'Keys are required',
                },
              },
              {
                key: 'targetField',
                type: 'radio',
                label: 'Target Field',
                tip: 'Primary contact field name or custom field UI key',
                addOptions: true,
                options: 'mapping-fields',
                v_required: {
                  value: true,
                  err: 'Target field is required',
                },
              },
            ],
          },
        },
      ],
    },
    CRM_CONTACT_VALUE_MAPPING: {
      key: 'CRM_CONTACT_VALUE_MAPPING',
      category: 'crm',
      section: 'contacts',
      visibility: 'internal',
      title: 'Contact Value Mapping',
      description: 'Map incoming form, Meta lead and WhatsApp flow values to target values for contact fields (e.g. "Yes, aligned" to "Yes")',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_CONTACT_VALUE_MAPPING',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'Contact value mapping is required',
          },
          listConfig: {
            addButtonText: 'Add Value Mapping',
            flatStorage: false,
            rowFields: [
              {
                key: 'targetField',
                type: 'radio',
                label: 'Target Field',
                tip: 'Primary contact field name or custom field UI key',
                addOptions: true,
                options: 'mapping-fields',
                v_required: {
                  value: true,
                  err: 'Target field is required',
                },
              },
              {
                key: 'from',
                type: 'edit_text',
                label: 'Incoming Value',
                tip: 'Value as received (case-insensitive; may contain commas, cannot contain "|" or ";")',
                v_required: {
                  value: true,
                  err: 'Incoming value is required',
                },
              },
              {
                key: 'to',
                type: 'edit_text',
                label: 'Target Value',
                tip: 'Value to store on the contact',
                v_required: {
                  value: true,
                  err: 'Target value is required',
                },
              },
            ],
          },
        },
      ],
    },
    CRM_CONTACT_ENROLL: {
      key: 'CRM_CONTACT_ENROLL',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Enroll Action',
      description: 'Enable contact enrollment into drip sequence',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_CONTACT_ENRICH: {
      key: 'CRM_CONTACT_ENRICH',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Enrich Action',
      description: 'Enable contact enrichment (friendly name and company name)',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_CONTACT_ENRICH_PHONE: {
      key: 'CRM_CONTACT_ENRICH_PHONE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Enrich Phone Action',
      description: 'Enable phone enrichment for contacts',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    MAX_TENANT_PROSPECTING_PROSPEO_CREDITS: {
      key: 'MAX_TENANT_PROSPECTING_PROSPEO_CREDITS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Prospect Credits',
      description: 'Maximum prospect credits per tenant',
      type: 'number',
      defaultValue: '500',
      fields: [
        {
          key: 'MAX_TENANT_PROSPECTING_PROSPEO_CREDITS',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX TENANT PROSPECTING PROSPEO CREDITS is required',
          },
        },
      ],
    },
    MAX_TENANT_PHONE_FINDER_CREDITS: {
      key: 'MAX_TENANT_PHONE_FINDER_CREDITS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Phone Finder Credits',
      description: 'Maximum phone finder credits per tenant',
      type: 'number',
      defaultValue: '10',
      fields: [
        {
          key: 'MAX_TENANT_PHONE_FINDER_CREDITS',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX TENANT PHONE FINDER CREDITS is required',
          },
        },
      ],
    },
    CRM_CONTACT_EDIT_SUMMARY: {
      key: 'CRM_CONTACT_EDIT_SUMMARY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Edit Summary',
      description: 'Allow editing a contact from the summary card',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_CONTACT_EDIT_UTM_CAMPAIGN: {
      key: 'CRM_CONTACT_EDIT_UTM_CAMPAIGN',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Edit UTM Campaign',
      description: 'Show UTM Campaign field in contact edit dialogs',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    MAX_CONTACTS_BULK_IMPORT: {
      key: 'MAX_CONTACTS_BULK_IMPORT',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Contacts Bulk Import',
      description: 'Maximum contacts per bulk import',
      type: 'number',
      defaultValue: '500',
      fields: [
        {
          key: 'MAX_CONTACTS_BULK_IMPORT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX CONTACTS BULK IMPORT is required',
          },
        },
      ],
    },
    MAX_CONTACTS_BULK_UPDATE: {
      key: 'MAX_CONTACTS_BULK_UPDATE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Contacts Bulk Update',
      description: 'Maximum contacts per bulk update',
      type: 'number',
      defaultValue: '500',
      fields: [
        {
          key: 'MAX_CONTACTS_BULK_UPDATE',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX CONTACTS BULK UPDATE is required',
          },
        },
      ],
    },
    MAX_CONTACTS_BULK_PHONE_ENRICH: {
      key: 'MAX_CONTACTS_BULK_PHONE_ENRICH',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Contacts Bulk Phone Enrich',
      description: 'Maximum contacts per bulk phone enrich',
      type: 'number',
      defaultValue: '10',
      fields: [
        {
          key: 'MAX_CONTACTS_BULK_PHONE_ENRICH',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX CONTACTS BULK PHONE ENRICH is required',
          },
        },
      ],
    },
    MAX_CONTACTS_BULK_EXPORT_FILTERED: {
      key: 'MAX_CONTACTS_BULK_EXPORT_FILTERED',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Contacts Bulk Export (Filtered)',
      description: 'Maximum contacts per filtered bulk export',
      type: 'number',
      defaultValue: '10000',
      fields: [
        {
          key: 'MAX_CONTACTS_BULK_EXPORT_FILTERED',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX CONTACTS BULK EXPORT FILTERED is required',
          },
        },
      ],
    },
    MAX_CONTACTS_BULK_EXPORT: {
      key: 'MAX_CONTACTS_BULK_EXPORT',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Contacts Bulk Export',
      description: 'Maximum contacts per bulk export',
      type: 'number',
      defaultValue: '10000',
      fields: [
        {
          key: 'MAX_CONTACTS_BULK_EXPORT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX CONTACTS BULK EXPORT is required',
          },
        },
      ],
    },
    CRM_CONTACT_EXPORT_LATEST_NOTE: {
      key: 'CRM_CONTACT_EXPORT_LATEST_NOTE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Export Latest Note',
      description: 'When enabled, always include latestNote in contact exports (including full and filtered). When disabled, latestNote is only included for non-full, non-filtered exports.',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    BI_EXPORT_FIELD_POLICY: {
      key: 'BI_EXPORT_FIELD_POLICY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'BI export field policy',
      description: 'JSON: { contacts: { fields: [{ key, mode: plain|hash|presence }], includeLiveCustomFields?, customShortTextMode? }, interactions: { fields: [...] }, hashSalt? }. Custom fields export as uiKey Parquet columns (dbKey in manifest); do not rename uiKey without updating Power BI. Empty = code defaults.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'BI_EXPORT_FIELD_POLICY',
          type: 'edit_text',
          placement: 'left',
          rows: '12',
          multiline: true,
          v_required: { value: false, err: 'Field policy required' },
        },
      ],
    },
    CRM_CONTACT_SHOW_LATEST_NOTE: {
      key: 'CRM_CONTACT_SHOW_LATEST_NOTE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Show Latest Note',
      description: 'When enabled, show latest note in the contacts list.',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACTS_CONTACTS_FINDER: {
      key: 'CRM_CONTACTS_CONTACTS_FINDER',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Contacts Finder',
      description: 'When enabled, show the Find Contacts action on the Contacts page.',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_CONTACT_SUMMARY_FIELDS: {
      key: 'CRM_CONTACT_SUMMARY_FIELDS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Summary Fields',
      description: 'Contact summary fields',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_CONTACT_SUMMARY_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT SUMMARY FIELDS is required',
          },
          options: 'crm-contact-fields',
        },
      ],
    },
    CRM_CONTACT_INFO_FIELDS: {
      key: 'CRM_CONTACT_INFO_FIELDS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Info Fields',
      description: 'Contact info fields',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_CONTACT_INFO_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT INFO FIELDS is required',
          },
          options: 'crm-contact-fields',
        },
      ],
    },
    CRM_CONTACT_HIDE_STATUS: {
      key: 'CRM_CONTACT_HIDE_STATUS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Hidden Lead States',
      description: 'Lead states to hide',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_CONTACT_HIDE_STATUS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT HIDE STATUS is required',
          },
          options: 'crm-contact-states',
        },
      ],
    },
    CRM_CONTACT_EDIT_INTERACTION_FIELDS: {
      key: 'CRM_CONTACT_EDIT_INTERACTION_FIELDS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Edit Interaction Fields',
      description: 'Editable fields in EDIT interaction',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_CONTACT_EDIT_INTERACTION_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT EDIT INTERACTION FIELDS is required',
          },
          options: 'crm-contact-fields',
        },
      ],
    },
    CRM_CONTACT_PREVIEW_TEMPLATE: {
      key: 'CRM_CONTACT_PREVIEW_TEMPLATE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Preview Fields (list view)',
      description: 'Contact preview fields',
      type: 'list',
      defaultValue: '',
      levels: ['platform'],
      listSerializer: 'labeled',
      labelsFieldKey: 'CRM_CONTACT_PREVIEW_TEMPLATE_LABELS',
      fields: [
        {
          key: 'CRM_CONTACT_PREVIEW_TEMPLATE',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT PREVIEW TEMPLATE is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'column1',
                type: 'radio',
                label: 'Column 1',
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-contact-preview-fields',
              },
              {
                key: 'column2',
                type: 'radio',
                label: 'Column 2',
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-contact-preview-fields',
              },
              {
                key: 'column3',
                type: 'radio',
                label: 'Column 3',
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-contact-preview-fields',
              },
              {
                key: 'column4',
                type: 'radio',
                label: 'Column 4',
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-contact-preview-fields',
              }
            ],
          },
        },
        {
          key: 'CRM_CONTACT_PREVIEW_TEMPLATE_LABELS',
          type: 'check_box',
          label: 'Fields with labels enabled',
          placement: 'left',
          fullWidth: true,
          v_required: {
            value: false,
            err: '',
          },
          options: 'crm-contact-preview-fields',
        }
      ],
    },
    CRM_CUSTOM_STAT_CARDS: {
      key: 'CRM_CUSTOM_STAT_CARDS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Custom Stat Cards',
      description: 'Custom CRM dashboard stat cards',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_CUSTOM_STAT_CARDS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CUSTOM STAT CARDS is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'key',
                type: 'edit_text',
                label: 'Key',
                tip: 'Unique identifier for the stat card',
                v_required: {
                  value: true,
                  err: 'Key is required',
                },
              },
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Display label shown on the stat card',
                v_required: {
                  value: true,
                  err: 'Label is required',
                },
              },
              {
                key: 'filter',
                type: 'edit_text',
                label: 'Filter Query',
                tip: 'Query string that defines contacts counted by this card',
                v_required: {
                  value: true,
                  err: 'Filter is required',
                },
              }
            ],
          },
        }
      ],
    },
    CRM_CONTACTS_TAG_GROUPS: {
      key: 'CRM_CONTACTS_TAG_GROUPS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Contact Tag Groups',
      description: 'Groups of tags shown as filters in the Contacts Tags chart expansion table',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_CONTACTS_TAG_GROUPS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'Contact tag groups are required',
          },
          listConfig: {
            addButtonText: 'Add Group',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'title',
                type: 'edit_text',
                label: 'Title',
                tip: 'Display name for this tag group',
                v_required: {
                  value: true,
                  err: 'Title is required',
                },
              },
              {
                key: 'tags',
                type: 'check_box',
                label: 'Tags',
                tip: 'Tags included in this group',
                v_required: {
                  value: true,
                  err: 'Tags are required',
                },
                options: 'crm-contact-chart-tags',
              },
            ],
          },
        }
      ],
    },
    CRM_CONTACT_TAB_MODE: {
      key: 'CRM_CONTACT_TAB_MODE',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Contact Tab Mode',
      description: 'Default contact list tabs when CRM_CONTACT_CUSTOM_TABS is not set. LEGACY uses no tabs; NEW uses All/New/Active/Followups. CRM_CONTACT_CUSTOM_TABS takes precedence when set.',
      type: 'radio',
      defaultValue: 'NEW',
      fields: [
        {
          key: 'CRM_CONTACT_TAB_MODE',
          type: 'radio',
          placement: 'left',
          options: [
            { key: 'LEGACY', label: 'LEGACY' },
            { key: 'NEW', label: 'NEW' },
          ],
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    CRM_CONTACT_CUSTOM_TABS: {
      key: 'CRM_CONTACT_CUSTOM_TABS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Custom Tabs',
      description: 'Custom tabs shown on the CRM contact list view (label, filter, _sortKey, active). Takes precedence over CRM_CONTACT_TAB_MODE when set.',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_CONTACT_CUSTOM_TABS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM CONTACT CUSTOM TABS is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Tab name shown on the CRM contact list view',
                v_required: {
                  value: true,
                  err: 'Label is required',
                },
              },
              {
                key: 'filter',
                type: 'edit_text',
                label: 'Filter Query',
                tip: 'Query string applied when this tab is selected',
                v_required: {
                  value: false,
                  err: '',
                },
              },
              {
                key: '_sortKey',
                type: 'edit_text',
                label: 'Sort Key',
                tip: 'Default sort field for this tab (e.g. activeIntSentTs)',
                v_required: {
                  value: false,
                  err: '',
                },
              },
              {
                key: '_sortOrder',
                type: 'edit_text',
                label: 'Sort Order',
                tip: 'Sort direction: asc or desc',
                v_required: {
                  value: false,
                  err: '',
                },
              },
              {
                key: 'active',
                type: 'edit_text',
                label: 'Active (true/false)',
                tip: 'Set to true to mark this tab as the default active tab',
                v_required: {
                  value: false,
                  err: '',
                },
              },
            ],
          },
        }
      ],
    },
    CRM_UNIBOX_SORT_KEY: {
      key: 'CRM_UNIBOX_SORT_KEY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Unibox Sort Key',
      description: 'Default sort key for Unibox',
      type: 'string',
      defaultValue: 'activeIntSentTs',
      fields: [
        { key: 'CRM_UNIBOX_SORT_KEY', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    CRM_CONTACT_DEFAULT_FILTER: {
      key: 'CRM_CONTACT_DEFAULT_FILTER',
      category: 'crm',
      section: 'contacts',
      title: 'Default Filter',
      description: 'Default query string applied when navigating to contacts via the drawer menu',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_CONTACT_DEFAULT_FILTER',
          type: 'edit_text',
          label: 'Query String',
          placement: 'left',
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    CRM_CONTACT_AUTO_REFRESH: {
      key: 'CRM_CONTACT_AUTO_REFRESH',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Auto Refresh',
      description: 'Enable auto refresh controls on CRM contacts views',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_AUTO_LEAD_DEDUPLICATION: {
      key: 'CRM_AUTO_LEAD_DEDUPLICATION',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Auto Lead Deduplication',
      description: 'When enabled, inbound ExtInteractions / form identity lookups that find multiple live phone or email twins collapse them onto a canonical lead before continuing',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    EXT_INTERACTION_ALTERNATE_EMAIL_UI_KEY: {
      key: 'EXT_INTERACTION_ALTERNATE_EMAIL_UI_KEY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'ExtInteraction Alternate Email Field',
      description: 'Custom field uiKey used when an ExtInteraction profile email cannot be saved on the lead email. Empty skips the write. The field must already exist on the tenant.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'EXT_INTERACTION_ALTERNATE_EMAIL_UI_KEY',
          type: 'edit_text',
          label: 'Alternate Email uiKey',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    EXT_INTERACTION_ALTERNATE_PHONE_UI_KEY: {
      key: 'EXT_INTERACTION_ALTERNATE_PHONE_UI_KEY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'ExtInteraction Alternate Phone Field',
      description: 'Custom field uiKey used when an ExtInteraction profile phone differs from the lead phone. Empty skips the write. The field must already exist on the tenant.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'EXT_INTERACTION_ALTERNATE_PHONE_UI_KEY',
          type: 'edit_text',
          label: 'Alternate Phone uiKey',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    EXT_INTERACTION_FALLBACK_STAFF_EMAIL: {
      key: 'EXT_INTERACTION_FALLBACK_STAFF_EMAIL',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'ExtInteraction Fallback Staff',
      description: 'Optional staff email used when an ExtInteraction agentEmail does not match a staff user. Empty keeps the staffNotFound error. A disabled staff user is valid. An unknown email is ignored and the interaction still fails as staffNotFound. When used, the incoming agent email is stored on the interaction.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'EXT_INTERACTION_FALLBACK_STAFF_EMAIL',
          type: 'edit_text',
          label: 'Fallback Staff Email',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    WEBHOOK_PUSH_MAX_ATTEMPTS: {
      key: 'WEBHOOK_PUSH_MAX_ATTEMPTS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Webhook Push Max Attempts',
      description: 'Total HTTP attempts for lead webhook push (minimum 1, default 1, capped at 3). Retries wait 500ms, then 1s.',
      type: 'number',
      defaultValue: '1',
      fields: [
        {
          key: 'WEBHOOK_PUSH_MAX_ATTEMPTS',
          type: 'edit_text',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    SARVAM_CONFIG: {
      key: 'SARVAM_CONFIG',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Sarvam outbound config',
      description: 'JSON config for CALL_OUTBOUND provider SARVAM (non-sensitive). Example: {"sarvamOrgId":"...","workspaceId":"...","connections":[{"title":"Default","connectionId":"...","agentPhoneNumber":"+91..."}],"outputVariablePrefix":"out_"}. Each CALL_OUTBOUND rule action picks one connection by title (defaults to the first); titles must be unique. outputVariablePrefix (optional, default "out_", "" disables) is stripped from variable names the agent returns before mapping, e.g. out_leadstate -> leadstate; unprefixed names still map. outcomeVariable (optional, default "calloutcome") names the agent output variable whose value (trimmed, lowercased) becomes callOutcome on the CALL_OUTBOUND_COMPLETED rule event; it is never written to a contact field. The Sarvam connection, app ID, app version and the lead details sent to the agent are set on each CALL_OUTBOUND rule action. API key + webhookToken live in msSecret2[orgId].sarvam.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'SARVAM_CONFIG',
          type: 'edit_text',
          label: 'Sarvam JSON config',
          placement: 'left',
          rows: '6',
          multiline: true,
          v_required: { value: false, err: '' },
        },
      ],
    },
    ZOOM_RECONCILIATION_MEETING_IDS: {
      key: 'ZOOM_RECONCILIATION_MEETING_IDS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Zoom reconciliation meeting IDs',
      description: 'Numeric Zoom meeting IDs to include in nightly AUTO_ZOOM_RECONCILIATION (non-empty enables the tenant)',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'ZOOM_RECONCILIATION_MEETING_IDS',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'Meeting IDs',
          tip: 'Add Zoom meeting IDs (recurring series id) to reconcile after each session',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    CRM_FILTER_ALERT: {
      key: 'CRM_FILTER_ALERT',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'CRM Filter Alert',
      description: 'Daily alert when filtered CRM lead count meets or exceeds the threshold. Each alert has a title used in the email subject/body. Non-empty enables the tenant for the 6pm CRM_FILTER_ALERT report.',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'CRM_FILTER_ALERT',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM FILTER ALERT is required',
          },
          listConfig: {
            addButtonText: 'Add Alert',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'title',
                type: 'edit_text',
                label: 'Alert Title',
                tip: 'Short title used in the alert email subject and body',
                v_required: {
                  value: true,
                  err: 'Alert title is required',
                },
              },
              {
                key: 'emails',
                type: 'check_box',
                label: 'Notify emails',
                tip: 'Email addresses to notify when the filtered lead count meets or exceeds the threshold',
                addOptions: true,
                options: [],
                v_required: {
                  value: true,
                  err: 'Notify emails are required',
                },
              },
              {
                key: 'filter',
                type: 'edit_text',
                label: 'Filter Query',
                tip: 'Filter query string (filterqs) used to count matching CRM leads',
                v_required: {
                  value: true,
                  err: 'Filter is required',
                },
              },
              {
                key: 'threshold',
                type: 'edit_text',
                label: 'Threshold',
                tip: 'Alert when filtered lead count is greater than or equal to this number',
                v_required: {
                  value: true,
                  err: 'Threshold is required',
                },
              },
            ],
          },
        },
      ],
    },
    WEEKLY_INSIGHT_REPORT: {
      key: 'WEEKLY_INSIGHT_REPORT',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Weekly Insight Report',
      description: 'Recipient emails for the Monday 9am (IST) Slixta Insight email: unattended (NEW) leads, outbound calls and outbound emails in the last 7 days. Non-empty enables the tenant.',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'WEEKLY_INSIGHT_REPORT',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'Notify emails',
          tip: 'Email addresses that receive the weekly insight report',
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    LEAD_ROUTING_TRIGGERS: {
      key: 'LEAD_ROUTING_TRIGGERS',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Lead Routing Triggers',
      description: 'Select triggers that initiate lead routing',
      type: 'check_box',
      defaultValue: '',
      fields: [
        { key: 'LEAD_ROUTING_TRIGGERS', type: 'check_box', addOptions: true, options: [], placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    LEAD_ROUTING_MAX_STAFF_LOAD: {
      key: 'LEAD_ROUTING_MAX_STAFF_LOAD',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Max Staff Load',
      description: 'Maximum load for lead routing per staff member',
      type: 'number',
      defaultValue: '10',
      fields: [
        { key: 'LEAD_ROUTING_MAX_STAFF_LOAD', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    LEAD_ROUTING_CUSTOM_STRATEGY: {
      key: 'LEAD_ROUTING_CUSTOM_STRATEGY',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Lead Routing Custom Strategy',
      description: 'When set to program1, unlocks Program Load on the ROUTE_LEAD rule action',
      type: 'string',
      defaultValue: '',
      fields: [
        { key: 'LEAD_ROUTING_CUSTOM_STRATEGY', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    LEAD_ROUTING_ALT_FALLBACK_TEAM: {
      key: 'LEAD_ROUTING_ALT_FALLBACK_TEAM',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Lead Routing Alternate Fallback Team',
      description: 'Team ID (subOrgId) that gets LEAD_ROUTING_ALT_FALLBACK_PCT percent of DEMO_DATE_ELAPSED fallback leads (post-demo only), e.g. an AI calling team; the rest go to LEAD_ROUTING_FALLBACK_TEAM. Must be a team in the org and differ from LEAD_ROUTING_FALLBACK_TEAM. Off while either setting is unset.',
      type: 'string',
      defaultValue: '',
      fields: [
        { key: 'LEAD_ROUTING_ALT_FALLBACK_TEAM', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    LEAD_ROUTING_ALT_FALLBACK_PCT: {
      key: 'LEAD_ROUTING_ALT_FALLBACK_PCT',
      category: 'crm',
      section: 'contacts',
      visibility: 'developer',
      title: 'Lead Routing Alternate Fallback Percent',
      description: 'Whole number from 1 to 100: share of DEMO_DATE_ELAPSED fallback leads (post-demo only) routed to LEAD_ROUTING_ALT_FALLBACK_TEAM, by a stable hash of the lead user ID (e.g. 25 sends 25%). Other routing reasons are unaffected. Off while either setting is unset.',
      type: 'number',
      defaultValue: '',
      fields: [
        { key: 'LEAD_ROUTING_ALT_FALLBACK_PCT', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    CRM_ABM: {
      key: 'CRM_ABM',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Account Based Marketing',
      description: 'Enable ABM features',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_ACCOUNT_ENRICH: {
      key: 'CRM_ACCOUNT_ENRICH',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Enrich Action',
      description: 'Enable account enrichment',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    MAX_TENANT_ACCOUNT_ENRICH_CREDITS: {
      key: 'MAX_TENANT_ACCOUNT_ENRICH_CREDITS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Account Enrich Credits',
      description: 'Maximum account enrich credits per tenant',
      type: 'number',
      defaultValue: '10',
      fields: [
        {
          key: 'MAX_TENANT_ACCOUNT_ENRICH_CREDITS',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX TENANT ACCOUNT ENRICH CREDITS is required',
          },
        },
      ],
    },
    CRM_ACCOUNT_EDIT_SUMMARY: {
      key: 'CRM_ACCOUNT_EDIT_SUMMARY',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Edit Summary',
      description: 'Allow editing account from summary card',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_ACCOUNT_EDIT_INTERACTION: {
      key: 'CRM_ACCOUNT_EDIT_INTERACTION',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Edit Interaction',
      description: 'Add an EDIT interaction for accounts',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    CRM_RESTRICT_VIEW_ASSIGNED_ACCOUNTS: {
      key: 'CRM_RESTRICT_VIEW_ASSIGNED_ACCOUNTS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Restrict View to Assigned Accounts',
      description: 'Restrict account view to assigned accounts only',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    CRM_ACCOUNT_KEY_FIELD: {
      key: 'CRM_ACCOUNT_KEY_FIELD',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Account Key',
      description: 'Account unique key (custom field ui key). Use DEFAULT to use the built-in accountKey field (same as empty). With CRM_ACCOUNT_KEY_NORMALIZER DOMAIN, use domain (not websiteUrl).',
      type: 'string',
      defaultValue: 'domain',
      fields: [
        {
          key: 'CRM_ACCOUNT_KEY_FIELD',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM ACCOUNT KEY FIELD is required',
          },
        },
      ],
    },
    CRM_ACCOUNT_KEY_NORMALIZER: {
      key: 'CRM_ACCOUNT_KEY_NORMALIZER',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Account Key Normalizer',
      description: 'When DOMAIN, copy a normalised hostname onto accountKey from the custom key field (e.g. domain). The custom field is left unchanged. No-op if CRM_ACCOUNT_KEY_FIELD is empty.',
      type: 'radio',
      defaultValue: 'DOMAIN',
      fields: [
        {
          key: 'CRM_ACCOUNT_KEY_NORMALIZER',
          type: 'radio',
          placement: 'left',
          options: [
            { key: 'NONE', label: 'NONE' },
            { key: 'DOMAIN', label: 'DOMAIN' },
          ],
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    MAX_ACCOUNTS_BULK_IMPORT: {
      key: 'MAX_ACCOUNTS_BULK_IMPORT',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Max Accounts Bulk Import',
      description: 'Maximum accounts per bulk import',
      type: 'number',
      defaultValue: '500',
      fields: [
        {
          key: 'MAX_ACCOUNTS_BULK_IMPORT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX ACCOUNTS BULK IMPORT is required',
          },
        },
      ],
    },
    MAX_ACCOUNTS_BULK_ENRICH: {
      key: 'MAX_ACCOUNTS_BULK_ENRICH',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Max Accounts Bulk Enrich',
      description: 'Maximum accounts per bulk enrich',
      type: 'number',
      defaultValue: '50',
      fields: [
        {
          key: 'MAX_ACCOUNTS_BULK_ENRICH',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX ACCOUNTS BULK ENRICH is required',
          },
        },
      ],
    },
    MAX_ACCOUNTS_BULK_EXPORT_FILTERED: {
      key: 'MAX_ACCOUNTS_BULK_EXPORT_FILTERED',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Max Accounts Bulk Export (Filtered)',
      description: 'Maximum accounts per filtered bulk export',
      type: 'number',
      defaultValue: '10000',
      fields: [
        {
          key: 'MAX_ACCOUNTS_BULK_EXPORT_FILTERED',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX ACCOUNTS BULK EXPORT FILTERED is required',
          },
        },
      ],
    },
    MAX_ACCOUNTS_BULK_EXPORT: {
      key: 'MAX_ACCOUNTS_BULK_EXPORT',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Max Accounts Bulk Export',
      description: 'Maximum accounts per bulk export',
      type: 'number',
      defaultValue: '10000',
      fields: [
        {
          key: 'MAX_ACCOUNTS_BULK_EXPORT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX ACCOUNTS BULK EXPORT is required',
          },
        },
      ],
    },
    CRM_ACCOUNT_INFO_FIELDS: {
      key: 'CRM_ACCOUNT_INFO_FIELDS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Info Fields',
      description: 'Account info fields',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_ACCOUNT_INFO_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM ACCOUNT INFO FIELDS is required',
          },
          options: 'crm-account-fields',
        },
      ],
    },
    CRM_ACCOUNT_SUMMARY_FIELDS: {
      key: 'CRM_ACCOUNT_SUMMARY_FIELDS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Summary Fields',
      description: 'Account summary fields',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_ACCOUNT_SUMMARY_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM ACCOUNT SUMMARY FIELDS is required',
          },
          options: 'crm-account-fields',
        },
      ],
    },
    CRM_ACCOUNT_EDIT_INTERACTION_FIELDS: {
      key: 'CRM_ACCOUNT_EDIT_INTERACTION_FIELDS',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Edit Interaction Fields',
      description: 'Editable fields in EDIT interaction',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_ACCOUNT_EDIT_INTERACTION_FIELDS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM ACCOUNT EDIT INTERACTION FIELDS is required',
          },
          options: 'crm-account-fields',
        },
      ],
    },
    CRM_ACCOUNT_PREVIEW_TEMPLATE: {
      key: 'CRM_ACCOUNT_PREVIEW_TEMPLATE',
      category: 'crm',
      section: 'accounts',
      visibility: 'developer',
      title: 'Preview Fields (list view)',
      description: 'Account preview fields',
      type: 'list',
      defaultValue: '',
      listSerializer: 'labeled',
      labelsFieldKey: 'CRM_ACCOUNT_PREVIEW_TEMPLATE_LABELS',
      fields: [
        {
          key: 'CRM_ACCOUNT_PREVIEW_TEMPLATE',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM ACCOUNT PREVIEW TEMPLATE is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'column1',
                type: 'radio',
                label: 'Column 1',
                addOptions: true,
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-account-fields',
              },
              {
                key: 'column2',
                type: 'radio',
                label: 'Column 2',
                addOptions: true,
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-account-fields',
              },
              {
                key: 'column3',
                type: 'radio',
                label: 'Column 3',
                addOptions: true,
                v_required: {
                  value: false,
                  err: '',
                },
                options: 'crm-account-fields',
              }
            ],
          },
        },
        {
          key: 'CRM_ACCOUNT_PREVIEW_TEMPLATE_LABELS',
          type: 'check_box',
          label: 'Fields with labels enabled',
          addOptions: true,
          placement: 'left',
          fullWidth: true,
          v_required: {
            value: false,
            err: '',
          },
          options: 'crm-account-fields',
        }
      ],
    },
    CRM_ACCOUNT_DEFAULT_FILTER: {
      key: 'CRM_ACCOUNT_DEFAULT_FILTER',
      category: 'crm',
      section: 'accounts',
      title: 'Default Account Filter',
      description: 'Default query string applied when navigating to accounts via the drawer menu',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_ACCOUNT_DEFAULT_FILTER',
          type: 'edit_text',
          label: 'Query String',
          placement: 'left',
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    CRM_INBOX_DEFAULT_EMAIL_CC: {
      key: 'CRM_INBOX_DEFAULT_EMAIL_CC',
      category: 'crm',
      section: 'inboxes',
      visibility: 'developer',
      title: 'Default Email Cc',
      description: 'Default CC emails for inboxes',
      type: 'list',
      defaultValue: '',
      listSerializer: 'colonPairs',
      fields: [
        {
          key: 'CRM_INBOX_DEFAULT_EMAIL_CC',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM INBOX DEFAULT EMAIL CC is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'inbox',
                type: 'radio',
                label: 'Inbox',
                tip: 'Inbox email address, or all for every inbox',
                v_required: {
                  value: true,
                  err: 'Inbox is required',
                },
                options: 'crm-inboxes',
              },
              {
                key: 'cc_emails',
                type: 'check_box',
                label: 'Cc Emails',
                tip: 'Default CC email addresses for this inbox',
                addOptions: true,
                v_required: {
                  value: true,
                  err: 'Cc emails are required',
                },
                options: 'staff-emails',
              },
            ],
          },
        }
      ],
    },
    CRM_INBOX_DEFAULT_EMAIL_BCC: {
      key: 'CRM_INBOX_DEFAULT_EMAIL_BCC',
      category: 'crm',
      section: 'inboxes',
      visibility: 'developer',
      title: 'Default Email Bcc',
      description: 'Default BCC emails for inboxes',
      type: 'list',
      defaultValue: '',
      listSerializer: 'colonPairs',
      fields: [
        {
          key: 'CRM_INBOX_DEFAULT_EMAIL_BCC',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'CRM INBOX DEFAULT EMAIL BCC is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'inbox',
                type: 'radio',
                label: 'Inbox',
                tip: 'Inbox email address, or all for every inbox',
                v_required: {
                  value: true,
                  err: 'Inbox is required',
                },
                options: 'crm-inboxes',
              },
              {
                key: 'bcc_emails',
                type: 'check_box',
                label: 'Bcc Emails',
                tip: 'Default BCC email addresses for this inbox',
                addOptions: true,
                v_required: {
                  value: true,
                  err: 'Bcc emails are required',
                },
                options: 'staff-emails',
              },
            ],
          },
        },
      ],
    },
    CRM_INBOX_DEFAULT_FOR_REPLY_EMAIL: {
      key: 'CRM_INBOX_DEFAULT_FOR_REPLY_EMAIL',
      category: 'crm',
      section: 'inboxes',
      visibility: 'developer',
      title: 'Reply Email default cc/bcc ',
      description: 'Use inbox default cc/bcc for reply email',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    CRM_INBOX_LEAD_SYNC_EXCLUDE_DOMAINS: {
      key: 'CRM_INBOX_LEAD_SYNC_EXCLUDE_DOMAINS',
      category: 'crm',
      section: 'inboxes',
      visibility: 'developer',
      title: 'Lead Sync Exclude Domains',
      description: 'Email domains to treat as internal (not external) when syncing inbox leads',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'CRM_INBOX_LEAD_SYNC_EXCLUDE_DOMAINS',
          type: 'check_box',
          addOptions: true,
          options: [],
          label: 'Exclude Domains',
          tip: 'Add domains to treat as internal, e.g. company.com',
          placement: 'left',
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    AD_TEAMS: {
      key: 'AD_TEAMS',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'Ad Account Team Grouping',
      description: 'Group ad accounts into teams by ad account name prefix',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      levels: [],
      fields: [
        {
          key: 'AD_TEAMS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'AD TEAMS is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'key',
                type: 'edit_text',
                label: 'Key',
                tip: 'Unique team identifier used in filters',
                v_required: {
                  value: true,
                  err: 'Key is required',
                },
              },
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Display name for the team in ad reports',
                v_required: {
                  value: true,
                  err: 'Label is required',
                },
              },
              {
                key: 'prefix',
                type: 'edit_text',
                label: 'Prefix',
                tip: 'Ad account name prefix used to group accounts into this team',
                v_required: {
                  value: true,
                  err: 'Prefix is required',
                },
              }
            ],
          },
        }
      ],
    },
    LINKEDIN_ADS_RECONNECT: {
      key: 'LINKEDIN_ADS_RECONNECT',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'LinkedIn Ads Reconnect',
      description: 'Show the LinkedIn Ads reconnect button',
      type: 'boolean',
      defaultValue: 'SLIXTA',
      levels: ['team', 'user', 'role'],
    },
    ADS_ANALYSE: {
      key: 'ADS_ANALYSE',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'AI Analysis',
      description: 'Enable AI ads analysis',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    META_ADS_AD_VIEW_CONTACTS: {
      key: 'META_ADS_AD_VIEW_CONTACTS',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'Meta Ad-wise View Contacts',
      description: 'Show the View Contacts button in the ad-wise breakup of Meta campaigns',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    GOOGLE_ADS_AD_VIEW_CONTACTS: {
      key: 'GOOGLE_ADS_AD_VIEW_CONTACTS',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'Google Ad-wise View Contacts',
      description: 'Show the View Contacts button in the ad-wise breakup of Google campaigns',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    LINKEDIN_ADS_AD_VIEW_CONTACTS: {
      key: 'LINKEDIN_ADS_AD_VIEW_CONTACTS',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'LinkedIn Ad-wise View Contacts',
      description: 'Show the View Contacts button in the ad-wise breakup of LinkedIn campaigns',
      type: 'boolean',
      defaultValue: 'enabled',
      levels: ['team', 'user', 'role'],
    },
    GOOGLE_AD_CAMPAIGNS_LIMIT: {
      key: 'GOOGLE_AD_CAMPAIGNS_LIMIT',
      category: 'ads',
      section: 'general',
      visibility: 'developer',
      title: 'Ad Campaigns Limit',
      description: 'Max limit for fetching Google Ad campaigns',
      type: 'number',
      defaultValue: '100',
      fields: [
        { key: 'GOOGLE_AD_CAMPAIGNS_LIMIT', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    META_AD_ACCOUNT_ID: {
      key: 'META_AD_ACCOUNT_ID',
      category: 'ads',
      section: 'accounts',
      visibility: 'internal',
      title: 'Meta Ad Accounts',
      description: 'Meta ad account IDs',
      type: 'list',
      defaultValue: '',
      listSerializer: 'equalsCommaPairs',
      fields: [
        {
          key: 'META_AD_ACCOUNT_ID',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'META AD ACCOUNT ID is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Display name for the ad account',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'accountId',
                type: 'edit_text',
                label: 'Account ID',
                tip: 'Meta ad account ID',
                v_required: {
                  value: true,
                  err: 'Account ID is required',
                },
              }
            ],
          },
        }
      ],
    },
    META_PAGE_IDS: {
      key: 'META_PAGE_IDS',
      category: 'ads',
      section: 'accounts',
      visibility: 'internal',
      title: 'Meta Page IDs',
      description: 'Facebook Pages to subscribe for Meta leadgen webhooks',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'META_PAGE_IDS',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: '',
          },
          listConfig: {
            addButtonText: 'Add Page',
            minItems: 0,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Display name for the Facebook Page',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'pageId',
                type: 'edit_text',
                label: 'Page ID',
                tip: 'Meta / Facebook Page ID',
                v_required: {
                  value: true,
                  err: 'Page ID is required',
                },
              },
            ],
          },
        },
      ],
    },
    DEFAULT_META_CAPI_DATASET_IDS: {
      key: 'DEFAULT_META_CAPI_DATASET_IDS',
      category: 'ads',
      section: 'accounts',
      visibility: 'developer',
      title: 'Meta CAPI Dataset IDs',
      description: 'Pixel / Dataset IDs available to SEND_META_CAPI rule actions. Each action picks one or more by label; each selected ID receives its own conversion POST.',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'DEFAULT_META_CAPI_DATASET_IDS',
          type: 'list',
          placement: 'left',
          v_required: { value: false, err: '' },
          listConfig: {
            addButtonText: 'Add Dataset',
            minItems: 0,
            flatStorage: false,
            rowFields: [
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Display name used when selecting this dataset on a SEND_META_CAPI rule action',
                v_required: { value: true, err: 'Label is required' },
              },
              {
                key: 'id',
                type: 'edit_text',
                label: 'ID',
                tip: 'Meta Pixel / Dataset ID',
                v_required: { value: true, err: 'Dataset ID is required' },
              },
            ],
          },
        },
      ],
    },
    GOOGLE_AD_ACCOUNT_ID: {
      key: 'GOOGLE_AD_ACCOUNT_ID',
      category: 'ads',
      section: 'accounts',
      visibility: 'internal',
      title: 'Google Ad Accounts',
      description: 'Google ad account IDs',
      type: 'list',
      defaultValue: '',
      listSerializer: 'equalsCommaPairs',
      fields: [
        {
          key: 'GOOGLE_AD_ACCOUNT_ID',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'GOOGLE AD ACCOUNT ID is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Display name for the ad account',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'accountId',
                type: 'edit_text',
                label: 'Account ID',
                tip: 'Google ad account ID',
                v_required: {
                  value: true,
                  err: 'Account ID is required',
                },
              }
            ],
          },
        }
      ],
    },
    LINKEDIN_AD_ACCOUNT_ID: {
      key: 'LINKEDIN_AD_ACCOUNT_ID',
      category: 'ads',
      section: 'accounts',
      visibility: 'internal',
      title: 'Linkedin Ad Accounts',
      description: 'LinkedIn ad account IDs',
      type: 'list',
      defaultValue: '',
      listSerializer: 'equalsCommaPairs',
      fields: [
        {
          key: 'LINKEDIN_AD_ACCOUNT_ID',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'LINKEDIN AD ACCOUNT ID is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Display name for the ad account',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'accountId',
                type: 'edit_text',
                label: 'Account ID',
                tip: 'LinkedIn ad account ID',
                v_required: {
                  value: true,
                  err: 'Account ID is required',
                },
              }
            ],
          },
        }
      ],
    },
    AUTOMATIONS_MENU: {
      key: 'AUTOMATIONS_MENU',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Automations',
      description: 'Enable the automations feature',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    AUTOMATION_VISUAL_BUILDER: {
      key: 'AUTOMATION_VISUAL_BUILDER',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Automation Visual Builder',
      description: 'Enable the visual builder for automations',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    WORKFLOWS_MENU: {
      key: 'WORKFLOWS_MENU',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Workflows',
      description: 'Enable the workflows menu item',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    DISCONNECT_LEGACY_WORKFLOWS: {
      key: 'DISCONNECT_LEGACY_WORKFLOWS',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Disconnect Legacy Workflows',
      description: 'When enabled, ignore tenantAdvSettings staff workflows (no triggerEvent) and return only Dynamo workflows for staff. Legacy migration status is empty. Does not disconnect event-triggered legacy workflows unless DISCONNECT_LEGACY_WORKFLOW_EVENTS is also enabled.',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    DISCONNECT_LEGACY_WORKFLOW_EVENTS: {
      key: 'DISCONNECT_LEGACY_WORKFLOW_EVENTS',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Disconnect Legacy Workflow Events',
      description: 'When enabled, ignore tenantAdvSettings workflows that have a triggerEvent (e.g. CONTACT_ENGAGEMENT, FORM_SUBMITTED). Default disabled so event workflows keep running from legacy after staff disconnect.',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    AUTOMATIONS_ADVANCED_FIELDS: {
      key: 'AUTOMATIONS_ADVANCED_FIELDS',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Advanced Fields',
      description: 'Enable advanced automations fields',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['team', 'user', 'role'],
    },
    AUTOMATED_EMAIL_SENDING_INBOX: {
      key: 'AUTOMATED_EMAIL_SENDING_INBOX',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Automated Email Sending Inbox',
      description: 'Inbox used to send automated emails from rules and workflows. Stores an inbox id.',
      type: 'radio',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'AUTOMATED_EMAIL_SENDING_INBOX',
          type: 'radio',
          placement: 'left',
          options: 'crm-inbox-ids',
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    AUTOMATED_EMAIL_TEMPLATES: {
      key: 'AUTOMATED_EMAIL_TEMPLATES',
      category: 'automations',
      section: 'general',
      visibility: 'developer',
      title: 'Automated Email Templates',
      description: 'Map stable template names to CRM email template ids. Rules and workflows SEND_EMAIL actions use these names.',
      type: 'list',
      defaultValue: '',
      listSerializer: 'colonPairs',
      levels: [],
      fields: [
        {
          key: 'AUTOMATED_EMAIL_TEMPLATES',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'AUTOMATED EMAIL TEMPLATES is required',
          },
          listConfig: {
            addButtonText: 'Add Template',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Stable name used by SEND_EMAIL actions (e.g. welcome)',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'templateId',
                type: 'radio',
                label: 'CRM email template',
                tip: 'CRM email template this name maps to',
                v_required: {
                  value: true,
                  err: 'Template ID is required',
                },
                options: 'crm-email-template-ids',
              },
            ],
          },
        },
      ],
    },
    WHATSAPP_MENU: {
      key: 'WHATSAPP_MENU',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp',
      description: 'Enable the WhatsApp feature',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    WHATSAPP_CHATBOTS: {
      key: 'WHATSAPP_CHATBOTS',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Chatbots',
      description: 'Enable the WhatsApp chatbots feature',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    WHATSAPP_CHATBOT_AGENT: {
      key: 'WHATSAPP_CHATBOT_AGENT',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Chatbot AI Agent',
      description: 'Enable the "Trigger Agent" chatbot node (hands the WhatsApp conversation to an external AI agent configured in WHATSAPP_CHATBOT_AGENT_CONFIG)',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    WHATSAPP_CHATBOT_AGENT_CONFIG: {
      key: 'WHATSAPP_CHATBOT_AGENT_CONFIG',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Chatbot AI Agent config',
      description: 'JSON config for "Trigger Agent" chatbot node providers (non-sensitive). Example: {"providers":[{"id":"iamlife","title":"IAmLife Agent","endpointUrl":"https://iamlife.io/api/chat","language":"en","timeoutMs":25000,"idleTimeoutHrs":24,"maxTurns":50,"endMarkerField":"conversationEnded"}]}. The endpoint is POSTed {message, sessionId, language} and must return {sessionId, message}; a truthy endMarkerField ends the agent conversation. Ids must be unique. No auth is sent. Debug only (default false): "debugAiLatency": true appends "[DEBUG] AI Latency: N ms" (agent API time) and "debugTotalLatency": true appends "[DEBUG] Total latency: N ms" (Lambda invocation to just before the reply is sent) to every agent reply the lead receives.',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'WHATSAPP_CHATBOT_AGENT_CONFIG',
          type: 'edit_text',
          label: 'AI agent JSON config',
          placement: 'left',
          rows: '6',
          multiline: true,
          v_required: { value: false, err: '' },
        },
      ],
    },
    MAX_TENANT_WA_BROADCAST_LIMIT: {
      key: 'MAX_TENANT_WA_BROADCAST_LIMIT',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Broadcast Credits',
      description: 'WhatsApp credits for sending broadcast or template messages',
      type: 'number',
      defaultValue: '5000',
      fields: [
        {
          key: 'MAX_TENANT_WA_BROADCAST_LIMIT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX TENANT WA BROADCAST LIMIT is required',
          },
        },
      ],
    },
    CRM_NUMBER_CONNECT_WHATSAPP: {
      key: 'CRM_NUMBER_CONNECT_WHATSAPP',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Number Onboarding',
      description: 'Enable the Connect to WhatsApp functionality for CRM numbers',
      type: 'boolean',
      defaultValue: 'SLIXTA',
      levels: ['team', 'user', 'role'],
    },
    MAX_RECIPIENTS_PER_WA_CAMPAIGN: {
      key: 'MAX_RECIPIENTS_PER_WA_CAMPAIGN',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'Max Recipients Per WA Campaign',
      description: 'Maximum recipients (max reachout) per WhatsApp campaign',
      type: 'number',
      defaultValue: '1000',
      fields: [
        {
          key: 'MAX_RECIPIENTS_PER_WA_CAMPAIGN',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX RECIPIENTS PER WA CAMPAIGN is required',
          },
        },
      ],
    },
    WA_INTERACTIONS_POLLING_INTERVAL: {
      key: 'WA_INTERACTIONS_POLLING_INTERVAL',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'Polling Interval',
      description: 'WhatsApp interactions polling interval (in ms)',
      type: 'number',
      defaultValue: '15000',
      fields: [
        { key: 'WA_INTERACTIONS_POLLING_INTERVAL', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    WA_QUICK_MESSAGE: {
      key: 'WA_QUICK_MESSAGE',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Quick Message',
      description: 'Enable quick message picker when sending WhatsApp messages in 1:1 chat',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    WA_TEMPLATE_TAGS: {
      key: 'WA_TEMPLATE_TAGS',
      category: 'whatsapp',
      section: 'general',
      visibility: 'developer',
      title: 'WhatsApp Template Keys',
      description: 'Stable keys that can be assigned to WhatsApp templates per WABA. Workflows resolve these keys to the mapped template name.',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'WA_TEMPLATE_TAGS',
          type: 'check_box',
          addOptions: true,
          options: [],
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    OPTIONS_ATC: {
      key: 'OPTIONS_ATC',
      category: 'automations',
      section: 'general',
      visibility: 'internal',
      title: 'Contact Failure Reasons (ATC)',
      description: 'Reasons for failing to reach a lead (used in Attempted to Contact workflows).',
      type: 'check_box',
      defaultValue: 'PHONE_BUSY,PHONE_UNREACHABLE,RINGING_NOT_RESPONDING,CALL_DISCONNECTED,NO_LOCAL_NUMBER,INCORRECT_NUMBER,WHATSAPP_NORESPONSE,LEFT_VOICEMAIL,CALL_BACK_LATER',
      fields: [
        {
          key: 'OPTIONS_ATC',
          type: 'check_box',
          addOptions: true,
          options: [
            { key: 'PHONE_BUSY', label: 'PHONE_BUSY' },
            { key: 'PHONE_UNREACHABLE', label: 'PHONE_UNREACHABLE' },
            { key: 'RINGING_NOT_RESPONDING', label: 'RINGING_NOT_RESPONDING' },
            { key: 'CALL_DISCONNECTED', label: 'CALL_DISCONNECTED' },
            { key: 'NO_LOCAL_NUMBER', label: 'NO_LOCAL_NUMBER' },
            { key: 'INCORRECT_NUMBER', label: 'INCORRECT_NUMBER' },
            { key: 'WHATSAPP_NORESPONSE', label: 'WHATSAPP_NORESPONSE' },
            { key: 'LEFT_VOICEMAIL', label: 'LEFT_VOICEMAIL' },
            { key: 'CALL_BACK_LATER', label: 'CALL_BACK_LATER' },
          ],
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    OPTIONS_UNQUALIFICATION: {
      key: 'OPTIONS_UNQUALIFICATION',
      category: 'automations',
      section: 'general',
      visibility: 'internal',
      title: 'Lead Unqualification Reasons',
      description: 'Reasons for disqualifying a lead (used in Mark as Unqualified workflows).',
      type: 'check_box',
      defaultValue: 'NOT_INTERESTED,LOCATION_MISMATCH,BUDGET_CONSTRAINT,NOT_ELIGIBLE,JUNK_LEAD,DUPLICATE,COMPETITOR,OTHER',
      fields: [
        {
          key: 'OPTIONS_UNQUALIFICATION',
          type: 'check_box',
          addOptions: true,
          options: [
            { key: 'NOT_INTERESTED', label: 'NOT_INTERESTED' },
            { key: 'LOCATION_MISMATCH', label: 'LOCATION_MISMATCH' },
            { key: 'BUDGET_CONSTRAINT', label: 'BUDGET_CONSTRAINT' },
            { key: 'NOT_ELIGIBLE', label: 'NOT_ELIGIBLE' },
            { key: 'JUNK_LEAD', label: 'JUNK_LEAD' },
            { key: 'DUPLICATE', label: 'DUPLICATE' },
            { key: 'COMPETITOR', label: 'COMPETITOR' },
            { key: 'OTHER', label: 'OTHER' },
          ],
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    OPTIONS_LOST: {
      key: 'OPTIONS_LOST',
      category: 'automations',
      section: 'general',
      visibility: 'internal',
      title: 'Opportunity Lost Reasons',
      description: 'Reasons for marking an opportunity as lost (used in Mark as Lost workflows).',
      type: 'check_box',
      defaultValue: 'CHOSE_COMPETITOR,PRICE_TOO_HIGH,NO_DECISION,FEATURE_MISMATCH,PROJECT_CANCELLED,TIMING_CANCELLED,NO_RESPONSE,OTHER',
      fields: [
        {
          key: 'OPTIONS_LOST',
          type: 'check_box',
          addOptions: true,
          options: [
            { key: 'CHOSE_COMPETITOR', label: 'CHOSE_COMPETITOR' },
            { key: 'PRICE_TOO_HIGH', label: 'PRICE_TOO_HIGH' },
            { key: 'NO_DECISION', label: 'NO_DECISION' },
            { key: 'FEATURE_MISMATCH', label: 'FEATURE_MISMATCH' },
            { key: 'PROJECT_CANCELLED', label: 'PROJECT_CANCELLED' },
            { key: 'TIMING_CANCELLED', label: 'TIMING_CANCELLED' },
            { key: 'NO_RESPONSE', label: 'NO_RESPONSE' },
            { key: 'OTHER', label: 'OTHER' },
          ],
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    OPTIONS_BADTIMING: {
      key: 'OPTIONS_BADTIMING',
      category: 'automations',
      section: 'general',
      visibility: 'internal',
      title: 'Follow-up Later / Bad Timing Reasons',
      description: 'Reasons for postponing lead engagement (used in Qualified for Later workflows).',
      type: 'check_box',
      defaultValue: 'CALL_BACK_NEXT_WEEK,CALL_BACK_NEXT_MONTH,NEXT_QUARTER,CURRENTLY_TRAVELING,BUDGET_CYCLE_LATER,RE_EVALUATING,OTHER',
      fields: [
        {
          key: 'OPTIONS_BADTIMING',
          type: 'check_box',
          addOptions: true,
          options: [
            { key: 'CALL_BACK_NEXT_WEEK', label: 'CALL_BACK_NEXT_WEEK' },
            { key: 'CALL_BACK_NEXT_MONTH', label: 'CALL_BACK_NEXT_MONTH' },
            { key: 'NEXT_QUARTER', label: 'NEXT_QUARTER' },
            { key: 'CURRENTLY_TRAVELING', label: 'CURRENTLY_TRAVELING' },
            { key: 'BUDGET_CYCLE_LATER', label: 'BUDGET_CYCLE_LATER' },
            { key: 'RE_EVALUATING', label: 'RE_EVALUATING' },
            { key: 'OTHER', label: 'OTHER' },
          ],
          placement: 'left',
          v_required: { value: false, err: '' },
        },
      ],
    },
    PRODUCT_STAFF_USER_LICENSE_COUNT: {
      key: 'PRODUCT_STAFF_USER_LICENSE_COUNT',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'User License Count',
      description: 'Number of staff user licenses',
      type: 'number',
      defaultValue: '5',
      fields: [
        {
          key: 'PRODUCT_STAFF_USER_LICENSE_COUNT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'PRODUCT STAFF USER LICENSE COUNT is required',
          },
        },
      ],
    },
    STAFF_INTERACTIONS_REPORT_COLUMNS: {
      key: 'STAFF_INTERACTIONS_REPORT_COLUMNS',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'Interactions Column Order',
      description: 'Columns to show first after STAFF in the staff interactions report, in order. Remaining columns follow in default order.',
      type: 'check_box',
      defaultValue: '',
      fields: [
        {
          key: 'STAFF_INTERACTIONS_REPORT_COLUMNS',
          type: 'check_box',
          addOptions: true,
          placement: 'left',
          v_required: {
            value: false,
            err: '',
          },
          options: 'interactions'
        },
      ],
    },
    STAFF_ACTIVITY_EXPORT_LIMIT: {
      key: 'STAFF_ACTIVITY_EXPORT_LIMIT',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'Staff Activity Export Limit',
      description: 'Maximum staff interactions exported per staff activity export',
      type: 'number',
      defaultValue: '10000',
      fields: [
        {
          key: 'STAFF_ACTIVITY_EXPORT_LIMIT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'STAFF ACTIVITY EXPORT LIMIT is required',
          },
        },
      ],
    },
    STAFF_DELETE_BUTTON: {
      key: 'STAFF_DELETE_BUTTON',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'Delete Button',
      description: 'Show staff delete action on staff list',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: ['platform', 'team', 'user', 'role'],
    },
    VIEWER_ENHANCED: {
      key: 'VIEWER_ENHANCED',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'Enhanced Viewer',
      description: 'Allow VIEWER role users to access Broadcasts, WhatsApp Templates, and Staff pages',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    STAFF_CHECKIN: {
      key: 'STAFF_CHECKIN',
      category: 'staff',
      section: 'general',
      visibility: 'developer',
      title: 'Staff Check-in',
      description: 'Enable staff check-in capabilities',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    MAX_INBOX_OUTREACH_LIMIT_PER_INTERVAL: {
      key: 'MAX_INBOX_OUTREACH_LIMIT_PER_INTERVAL',
      category: 'campaigns',
      section: 'drip_campaign_settings',
      visibility: 'developer',
      title: 'Daily Inbox Outreach Limit',
      description: 'Maximum inbox outreach per day',
      type: 'number',
      defaultValue: '15',
      fields: [
        {
          key: 'MAX_INBOX_OUTREACH_LIMIT_PER_INTERVAL',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX INBOX OUTREACH LIMIT PER INTERVAL is required',
          },
        },
      ],
    },
    MAX_DRIP_STEPS_PER_CAMPAIGN: {
      key: 'MAX_DRIP_STEPS_PER_CAMPAIGN',
      category: 'campaigns',
      section: 'drip_campaign_settings',
      visibility: 'developer',
      title: 'Max Steps Per Sequence',
      description: 'Maximum number of steps allowed in a drip sequence',
      type: 'number',
      defaultValue: '10',
      fields: [
        {
          key: 'MAX_DRIP_STEPS_PER_CAMPAIGN',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX_DRIP_STEPS_PER_CAMPAIGN is required',
          },
        },
      ],
    },
    MAX_DRIP_ENROLMENT_ACTIVE_DAYS: {
      key: 'MAX_DRIP_ENROLMENT_ACTIVE_DAYS',
      category: 'campaigns',
      section: 'drip_campaign_settings',
      visibility: 'developer',
      title: 'Max Enrolment Active Days',
      description: 'Maximum number of days a drip enrolment can stay live before it is force-completed',
      type: 'number',
      defaultValue: '180',
      fields: [
        {
          key: 'MAX_DRIP_ENROLMENT_ACTIVE_DAYS',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX_DRIP_ENROLMENT_ACTIVE_DAYS is required',
          },
        },
      ],
    },
    DRIP_CAMPAIGN_CHARTS: {
      key: 'DRIP_CAMPAIGN_CHARTS',
      category: 'campaigns',
      section: 'drip_campaign_settings',
      visibility: 'developer',
      title: 'Time-series Charts',
      description: 'Show outreach and reply timeseries charts on the sequences list page',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    DRIP_CAMPAIGN_DRILLDOWN_CHARTS: {
      key: 'DRIP_CAMPAIGN_DRILLDOWN_CHARTS',
      category: 'campaigns',
      section: 'drip_campaign_settings',
      visibility: 'developer',
      title: 'Time-series Charts (drill-down)',
      description: 'Show outreach and reply timeseries charts on the drip sequence detail page',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    MAX_TENANT_EMAIL_BROADCAST_LIMIT: {
      key: 'MAX_TENANT_EMAIL_BROADCAST_LIMIT',
      category: 'campaigns',
      section: 'email_broadcast_settings',
      visibility: 'developer',
      title: 'Broadcast Credits',
      description: 'Broadcast email credits',
      type: 'number',
      defaultValue: '5000',
      levels: [],
      fields: [
        {
          key: 'MAX_TENANT_EMAIL_BROADCAST_LIMIT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX_TENANT_EMAIL_BROADCAST_LIMIT is required',
          },
        },
      ],
    },
    MAX_RECIPIENTS_PER_EMAIL_CAMPAIGN: {
      key: 'MAX_RECIPIENTS_PER_EMAIL_CAMPAIGN',
      category: 'campaigns',
      section: 'email_broadcast_settings',
      visibility: 'developer',
      title: 'Maximum Recipients per Campaign',
      description: 'Maximum recipients per broadcast campaign',
      type: 'number',
      defaultValue: '5000',
      levels: [],
      fields: [
        {
          key: 'MAX_RECIPIENTS_PER_EMAIL_CAMPAIGN',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX_RECIPIENTS_PER_EMAIL_CAMPAIGN is required',
          },
        },
      ],
    },
    EMAIL_BROADCAST_MODE: {
      key: 'EMAIL_BROADCAST_MODE',
      category: 'campaigns',
      section: 'email_broadcast_settings',
      visibility: 'developer',
      title: 'Email Broadcast Mode',
      description: 'Mode for creating and executing email broadcasts',
      type: 'radio',
      defaultValue: 'NEW',
      fields: [
        {
          key: 'EMAIL_BROADCAST_MODE',
          type: 'radio',
          placement: 'left',
          options: [
            { key: 'LEGACY', label: 'LEGACY' },
            { key: 'EXPERIMENTAL', label: 'EXPERIMENTAL' },
            { key: 'NEW', label: 'NEW' },
          ],
          v_required: {
            value: false,
            err: '',
          },
        },
      ],
    },
    maxPopupViewsPerDay: {
      key: 'maxPopupViewsPerDay',
      category: 'campaigns',
      section: 'popups_settings',
      visibility: 'developer',
      title: 'Daily Popup Credits',
      description: 'Maximum popup views per day',
      type: 'number',
      defaultValue: '1000',
      fields: [
        {
          key: 'maxPopupViewsPerDay',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'MAX POPUP VIEWS PER DAY is required',
          },
        },
      ],
    },
    tagPageviewLogging: {
      key: 'tagPageviewLogging',
      category: 'campaigns',
      section: 'popups_settings',
      visibility: 'developer',
      title: 'Website Page View Logging',
      description: 'Log website page views from the Slixta tag (visitor IP, page, referrer)',
      type: 'boolean',
      defaultValue: 'enabled',
      levels: [],
    },
    tagPageviewEsIndex: {
      key: 'tagPageviewEsIndex',
      category: 'campaigns',
      section: 'popups_settings',
      visibility: 'developer',
      title: 'Website Page View Indexing',
      description: 'Index new website page views for visitor analytics (needs Website Page View Logging)',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    tagHonorGpc: {
      key: 'tagHonorGpc',
      category: 'campaigns',
      section: 'popups_settings',
      visibility: 'developer',
      title: 'Honour Global Privacy Control',
      description: 'Stop tracking website visitors whose browser sends Global Privacy Control (needed under CCPA/CPRA and similar laws)',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    WHATSAPP_NOTIFICATION: {
      key: 'WHATSAPP_NOTIFICATION',
      category: 'mobile-view',
      section: 'general',
      visibility: 'internal',
      title: 'Push Notifications for WhatsApp Messages',
      description: 'Enable push notifications on mobile app for WhatsApp messages',
      type: 'boolean',
      defaultValue: 'enabled',
    },
    LEAD_ASSIGNMENT_NOTIFICATION: {
      key: 'LEAD_ASSIGNMENT_NOTIFICATION',
      category: 'mobile-view',
      section: 'general',
      visibility: 'internal',
      title: 'Push Notifications for Lead Assignment',
      description: 'Enable push notifications on mobile app for lead assignment',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    DRAWER_MENU_LABELS_MOBILE: {
      key: 'DRAWER_MENU_LABELS_MOBILE',
      category: 'mobile-view',
      section: 'general',
      visibility: 'developer',
      title: 'Menu Labels',
      description: 'Override mobile drawer menu labels',
      type: 'list',
      defaultValue: '',
      listSerializer: 'keyValuePairs',
      fields: [
        {
          key: 'DRAWER_MENU_LABELS_MOBILE',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'DRAWER MENU LABELS MOBILE is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'key',
                type: 'edit_text',
                label: 'Key',
                tip: 'Drawer menu item key to override',
                v_required: {
                  value: true,
                  err: 'Key is required',
                },
              },
              {
                key: 'label',
                type: 'edit_text',
                label: 'Label',
                tip: 'Custom display label for this menu item',
                v_required: {
                  value: true,
                  err: 'Label is required',
                },
              }
            ],
          },
        }
      ],
    },
    RELOAD_APP: {
      key: 'RELOAD_APP',
      category: 'mobile-view',
      section: 'general',
      visibility: 'developer',
      title: 'Reload App',
      description: 'Enable reload app functionality',
      type: 'boolean',
      defaultValue: 'disabled',
    },
    GOOGLE_ANALYTICS_CONFIG: {
      key: 'GOOGLE_ANALYTICS_CONFIG',
      category: 'web-analytics',
      section: 'general',
      visibility: 'internal',
      title: 'Google Analytics Properties',
      description: 'Google Analytics property IDs',
      type: 'list',
      defaultValue: '',
      listSerializer: 'equalsCommaPairs',
      fields: [
        {
          key: 'GOOGLE_ANALYTICS_CONFIG',
          type: 'list',
          placement: 'left',
          v_required: {
            value: false,
            err: 'GOOGLE ANALYTICS CONFIG is required',
          },
          listConfig: {
            addButtonText: 'Add Row',
            minItems: 1,
            flatStorage: false,
            rowFields: [
              {
                key: 'name',
                type: 'edit_text',
                label: 'Name',
                tip: 'Website or property display name',
                v_required: {
                  value: true,
                  err: 'Name is required',
                },
              },
              {
                key: 'propertyId',
                type: 'edit_text',
                label: 'Property ID',
                tip: 'Google Analytics property ID',
                v_required: {
                  value: true,
                  err: 'Property ID is required',
                },
              }
            ],
          },
        }
      ],
    },
    DASHBOARD_RECORDINGS_LINK: {
      key: 'DASHBOARD_RECORDINGS_LINK',
      category: 'web-analytics',
      section: 'general',
      visibility: 'internal',
      title: 'Microsoft Clarity Link',
      description: 'Url to Microsoft Clarity analytics dashboard',
      type: 'string',
      defaultValue: '',
      fields: [
        {
          key: 'DASHBOARD_RECORDINGS_LINK',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'DASHBOARD RECORDINGS LINK is required',
          },
        },
      ],
    },
    googleAnalyticsPropertyId: {
      key: 'googleAnalyticsPropertyId',
      category: 'web-analytics',
      section: 'general',
      visibility: 'developer',
      title: 'Google Analytics Property ID',
      description: 'Google Analytics Property ID for the tenant',
      type: 'string',
      defaultValue: '',
      fields: [
        { key: 'googleAnalyticsPropertyId', type: 'edit_text', placement: 'left', v_required: { value: false, err: '' } }
      ],
    },
    INSIGHTS_PROMPT_CONTEXT: {
      key: 'INSIGHTS_PROMPT_CONTEXT',
      category: 'ai-insights',
      section: 'general',
      visibility: 'developer',
      title: 'Insights Prompt Context',
      description: 'Optional extra context appended to the insights AI prompt',
      type: 'string',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'INSIGHTS_PROMPT_CONTEXT',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'INSIGHTS PROMPT CONTEXT is required',
          },
        },
      ],
    },
    INSIGHTS_NOTIFICATION_EMAIL: {
      key: 'INSIGHTS_NOTIFICATION_EMAIL',
      category: 'ai-insights',
      section: 'general',
      visibility: 'developer',
      title: 'Insights Notification Email',
      description: 'Comma-separated recipient emails for the marketing insights report',
      type: 'string',
      defaultValue: '',
      levels: [],
      fields: [
        {
          key: 'INSIGHTS_NOTIFICATION_EMAIL',
          type: 'edit_text',
          placement: 'left',
          v_required: {
            value: false,
            err: 'INSIGHTS NOTIFICATION EMAIL is required',
          },
        },
      ],
    },
    FORM_SUBMITTED_NOTIFIER: {
      key: 'FORM_SUBMITTED_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Form Submitted',
      description: 'Form submitted notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    INBOX_INBOUND_EMAIL_NOTIFIER: {
      key: 'INBOX_INBOUND_EMAIL_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Inbox Inbound Email',
      description: 'Inbox inbound email notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_NOTE_MENTION_NOTIFIER: {
      key: 'CRM_NOTE_MENTION_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Contact Note Mentions',
      description: 'Note mention notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_CONTACT_UPDATED_NOTIFIER: {
      key: 'CRM_CONTACT_UPDATED_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Contact Assignee Update',
      description: 'Assignee update notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_CONTACT_TEAM_UPDATED_NOTIFIER: {
      key: 'CRM_CONTACT_TEAM_UPDATED_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Contact Team Update',
      description: 'Team update notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRMACCOUNT_NOTE_MENTION_NOTIFIER: {
      key: 'CRMACCOUNT_NOTE_MENTION_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Account Note Mentions',
      description: 'Account note mention notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
    CRM_ACCOUNT_UPDATED_NOTIFIER: {
      key: 'CRM_ACCOUNT_UPDATED_NOTIFIER',
      category: 'notifications',
      section: 'general',
      visibility: 'developer',
      title: 'Account Assignee Update',
      description: 'Account assignee update notification emails',
      type: 'boolean',
      defaultValue: 'disabled',
      levels: [],
    },
  }
};
